import { useEffect } from "react";
import Rodal from "rodal";
import { useSelector } from "react-redux";
import { dispatch } from "../../store";
import { IoCloseSharp } from "react-icons/io5";
import ErrorButton from "./ErrorButton";

export default function ErrorModal() {
  const errormodal = useSelector((state) => state.modal);

  useEffect(() => {
    if (errormodal.message) document.body.classList.add("position-fixed");
    else document.body.classList.remove("position-fixed");
  }, [errormodal]);

  return (
    <Rodal
      visible={!!errormodal.message}
      onClose={() => dispatch.modal.clear()}
      closeOnEsc
      showCloseButton={false}
      customStyles={{
        padding: 16,
        width: "max-content",
        maxWidth: "20rem",
        height: "max-content",
        maxHeight: "40rem",
        overflowY: "auto",
      }}
      customMaskStyles={{
        backgroundColor: "rgba(0, 0, 0, .7)",
      }}
      animation="fade">
      <div className="custom-modal-container">
        <div className="d-flex justify-content-end mb-3">
          <IoCloseSharp
            onClick={() => dispatch.modal.clear()}
            size={20}
            style={{ position: "relative", top: 0, right: 0 }}
          />
        </div>
        <div className="d-flex flex-column">
          <h6>{errormodal.message}</h6>
          <div className="d-flex gap-2">
            {errormodal.buttons.map((handler) => (
              <ErrorButton
                key={handler.text}
                cb={handler.cb}
                text={handler.text}
              />
            ))}
          </div>
        </div>
      </div>
    </Rodal>
  );
}
